// extracted by mini-css-extract-plugin
export var icon = "icon-module--icon--40b85";
export var icon__font = "icon-module--icon__font--f31d5";
export var icon__image = "icon-module--icon__image--85149";
export var icon__inline = "icon-module--icon__inline--8d58d";
export var icon__spin = "icon-module--icon__spin--6d01a";
export var icon__typing = "icon-module--icon__typing--2c9f3";
export var spin = "icon-module--spin--5cf6a";
export var typing = "icon-module--typing--136ed";